export const faq = {
  badge: "FAQ",
  title: "Domande frequenti",
  subtitle: "Tutto quello che devi sapere su DONKEY TRAVEL",
  items: {
    q1: {
      question: "Come funziona il sistema di Scambio?",
      answer:
        "È uno scambio diretto tra due proprietari. Vi mettete d'accordo sulle date (simultanee o differite) e le modalità. Niente punti, niente calcoli complicati, solo umano.",
    },
    q2: {
      question: "Devo scambiare nello stesso momento?",
      answer:
        "No! È tutto l'interesse del nostro sistema flessibile. Puoi accogliere Jean in aprile e andare da lui in ottobre. Questo permette anche di incontrarsi alla consegna delle chiavi!",
    },
    q3: {
      question: "Come sono verificati i membri?",
      answer:
        "Tutti i membri devono essere proprietari Airbnb verificati. Verifichiamo anche l'identità, l'alloggio e le recensioni Airbnb di ogni membro per garantire la sicurezza della comunità.",
    },
    q4: {
      question: "Cosa succede in caso di problemi?",
      answer:
        "Il nostro team di supporto è disponibile 7/7 per accompagnarti. Inoltre, il nostro sistema di recensioni e valutazioni permette di mantenere una comunità di fiducia e risolvere rapidamente ogni problema.",
    },
    q5: {
      question: "Ci sono costi nascosti?",
      answer:
        "No, nessun costo nascosto. Paghi solo il tuo abbonamento annuale secondo la zona geografica scelta. Gli scambi sono poi totalmente gratuiti, senza commissioni né costi aggiuntivi.",
    },
    q6: {
      question: "Posso scegliere chi soggiorna da me?",
      answer:
        "Assolutamente! Hai il controllo totale. Puoi consultare i profili, leggere le recensioni e accettare o rifiutare ogni richiesta di scambio secondo le tue preferenze.",
    },
    q7: {
      question: "La mia casa è assicurata durante gli scambi?",
      answer:
        "Sì, tutti gli scambi sono coperti dalla nostra assicurazione partner. Inoltre, raccomandiamo di verificare la tua assicurazione casa per una protezione ottimale.",
    },
    q8: {
      question: "Con quanto anticipo devo prenotare?",
      answer:
        "Dipende da ogni proprietario. Alcuni accettano prenotazioni last minute, altri preferiscono pianificare diversi mesi in anticipo. Raccomandiamo di prenotare almeno 2-3 settimane in anticipo.",
    },
  },
  cta: {
    title: "Hai altre domande?",
    subtitle:
      "Il nostro team è qui per aiutarti a iniziare la tua avventura DONKEY TRAVEL",
    button: "Contattaci",
  },
};
